var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageB(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 17.25C31.5052 19.2298 31.0426 21.1829 30.15 22.95C29.0916 25.0677 27.4646 26.8488 25.4512 28.094C23.4377 29.3391 21.1174 29.9991 18.75 30C16.7702 30.0052 14.8172 29.5426 13.05 28.65L4.5 31.5L7.35 22.95C6.4574 21.1829 5.99484 19.2298 6 17.25C6.00092 14.8827 6.66092 12.5623 7.90608 10.5489C9.15124 8.53542 10.9324 6.90839 13.05 5.85004C14.8172 4.95744 16.7702 4.49488 18.75 4.50004H19.5C22.6265 4.67253 25.5796 5.99218 27.7937 8.20633C30.0079 10.4205 31.3275 13.3735 31.5 16.5V17.25Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageB);
export default __webpack_public_path__ + "static/media/messageB.158b278af716078e3220920ddd9e77ab.svg";
export { ForwardRef as ReactComponent };